import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/index/index.vue";
import Detail from "@/views/detail1/index.vue";
import Appliction from "@/views/appliction/index.vue";
import News from "@/views/newsdetail/index.vue";
import News1 from "@/views/newsdetail1/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    meta: {
      title:
        "Premium quality chromium carbide overlay wear plates, hardfacing wires and wear plate fabrication | Hisan",
      keywords: "chromium carbide overlay, wear plate, CCO plate, hardfacing, abrasion resistant steel, HISAN, wear solution, overlay plate manufacturer, China wear plate supplier, anti-wear technology, welded overlay, chrome carbide plate, HISAN wear plate, custom wear plate, bimetallic wear plate, hardfaced plate, flux cored hardfacing wires, hardfacing wires, cored wires, wear plate fabrication, bulk material handling",
       description: "HISAN (Tianjin) Co., Ltd. is a trusted manufacturer and global supplier of premium Chromium Carbide Overlay (CCO) wear plates and hardfacing solutions. We provide bimetallic wear plates, custom fabrication, and flux cored hardfacing wires for mining, cement, steel, and bulk material handling industries."
        
    },
    component: Home,
  },
  {
    path: "/Why-choose-us",
    meta: { title: "Why choose us | Hisan",
     keywords: 'Why Choose HisanTech, Industrial Wear Solutions, Quality Wear Parts, Customized Wear Products, Wear Resistance, Industrial Durability, Trusted Wear Protection, High-Performance Wear Plates, Reliable Industrial Solutions, Wear Protection Experts',
            description: 'Discover why HisanTech is the trusted partner for industrial wear solutions. With our commitment to quality, advanced technology, and customized solutions, we deliver exceptional performance, durability, and value for your wear-resistant needs.'},
    component: () => import("../views/why"),
  },
  {
    path: "/Our-responsibility",
    meta: { title: "Our responsibility | Hisan" ,
     keywords: 'HisanTech Responsibility, Sustainable Manufacturing, Ethical Practices, Environmental Responsibility, Quality Assurance, Safe Operations, Corporate Social Responsibility, Sustainable Industrial Solutions, Ethical Manufacturing, Green Manufacturing Practices',
            description: 'At HisanTech, we are committed to sustainability and ethical practices. We take responsibility for the quality of our products, the safety of our operations, and our impact on the environment. Learn more about how we prioritize responsible manufacturing and contribute to a better future.'},
    component: () => import("../views/Our-responsibility"),
  },
  {
    path: "/privacy-policy",
    meta: {
      title:
        "Premium quality chromium carbide overlay wear plates, hardfacing wires and wear plate fabrication | Hisan",
      keywords: "privacy-policy,chromium carbide overlay, wear plate, CCO plate, hardfacing, abrasion resistant steel, HISAN, wear solution, overlay plate manufacturer, China wear plate supplier, anti-wear technology, welded overlay, chrome carbide plate, HISAN wear plate, custom wear plate, bimetallic wear plate, hardfaced plate, flux cored hardfacing wires, hardfacing wires, cored wires, wear plate fabrication, bulk material handling",
       description: "HISAN (Tianjin) Co., Ltd. is a trusted manufacturer and global supplier of premium Chromium Carbide Overlay (CCO) wear plates and hardfacing solutions. We provide bimetallic wear plates, custom fabrication, and flux cored hardfacing wires for mining, cement, steel, and bulk material handling industries."
        
    },
    component: () => import("../views/privacypolicy"),
  },
  {
    path: "/Production-capacity",
    meta: { title: "Production capacity | Hisan",
     keywords: 'chromium carbide overlay, wear plate, CCO plate, hardfacing, abrasion resistant steel, HISAN, wear solution, overlay plate manufacturer, China wear plate supplier, anti-wear technology, welded overlay, chrome carbide plate, HISAN wear plate, custom wear plate, bimetallic wear plate, hardfaced plate, flux cored hardfacing wires, hardfacing wires, cored wires, wear plate fabrication, bulk material handling',
            description: 'HISAN (Tianjin) Co., Ltd. is a trusted manufacturer and global supplier of premium Chromium Carbide Overlay (CCO) wear plates and hardfacing solutions. We provide bimetallic wear plates, custom fabrication, and flux cored hardfacing wires for mining, cement, steel, and bulk material handling industries.'},
    component: () => import("../views/capacity"),
  },
  {
    path: "/Research-ability",
    meta: { title: "Research ability | Hisan",
     keywords: 'chromium carbide overlay, wear plate, CCO plate, hardfacing, abrasion resistant steel, HISAN, wear solution, overlay plate manufacturer, China wear plate supplier, anti-wear technology, welded overlay, chrome carbide plate, HISAN wear plate, custom wear plate, bimetallic wear plate, hardfaced plate, flux cored hardfacing wires, hardfacing wires, cored wires, wear plate fabrication, bulk material handling',
            description: 'HISAN (Tianjin) Co., Ltd. is a trusted manufacturer and global supplier of premium Chromium Carbide Overlay (CCO) wear plates and hardfacing solutions. We provide bimetallic wear plates, custom fabrication, and flux cored hardfacing wires for mining, cement, steel, and bulk material handling industries.'},
    component: () => import("../views/ability"),
  },
  {
    path: "/Industry-news",
    meta: { title: "Industry news | Hisan",
     keywords: '',
            description: ''},
    component: () => import("../views/Industry"),
  },
  {
    path: "/Company-news",
    meta: { title: "Company news | Hisan",
     keywords: '',
            description: ''},
    component: () => import("../views/Company"),
  },
  {
    path: "/Wear-parts",
    meta: { title: "Wear plate fabrication cut to sized liner plates | Hisan",
     keywords: 'Wear Parts, Industrial Wear Parts, Wear Resistant Components, Abrasion Resistant Parts, Heavy Duty Wear Parts, Industrial Equipment Parts, Wear Protection, High-Performance Wear Parts, Wear-resistant Solutions, Custom Wear Parts',
            description: 'Explore high-quality wear parts from HisanTech, designed to provide exceptional durability and protection in demanding industrial applications. Our wear parts are engineered to resist abrasion, impact, and corrosion, ensuring extended service life and reduced maintenance costs.'},
    component: () => import("../views/parts"),
  },
  {
    path: "/Who-we-are",
    meta: { title: "Who we are | Hisan",
     keywords: 'HisanTech, About Us, Wear-Resistant Solutions, Industrial Wear Products, Chromium Carbide Wear Plates, Custom Manufacturing, Wear Protection, High-Quality Industrial Products, Company Profile, Industrial Solutions Provider',
            description: 'Discover HisanTech, a leader in wear-resistant solutions. We specialize in providing high-quality industrial products, including chromium carbide overlay wear plates, pipes, and custom solutions, backed by years of expertise and cutting-edge technology.'},
    component: () => import("../views/Who-we-are"),
  },
  {
    path: "/Industry-news/:productName",
    meta: { title: "Industry-news",
     keywords: '',
            description: ''},
    name: "News1",
    component: News1,
    props: true,
  },
  {
    path: "/Company-news/:productName",
    meta: { title: "Company-news",
     keywords: '',
            description: ''},
    name: "News",
    component: News,
    props: true,
  },
  {
    path: "/mining",
    meta: { title: "Mining wear solution | Hisan",
     keywords: '',
            description: ''},
    component: () => import("../views/mining"),
  },

  {
    path: "/cement",
    meta: { title: "cement",
     keywords: '',
            description: ''},
    component: () => import("../views/cement"),
  },
  {
    path: "/powerplant",
    meta: { title: "powerplant" },
    component: () => import("../views/powerplant"),
  },
  {
    path: "/bimetal",
    meta: { title: "bimetal",
     keywords: '',
            description: ''},
    component: () => import("../views/bimetal"),
  },
  {
    path: "/steelmill",
    meta: { title: "steelmill",
     keywords: '',
            description: ''},
    component: () => import("../views/steelmill"),
  },
  {
    path: "/bulk-material",
    meta: { title: "bulk-material",
     keywords: '',
            description: ''},
    component: () => import("../views/bulk-material"),
  },
  {
    path: "/nihard",
    meta: { title: "nihard",
     keywords: '',
            description: ''},
    component: () => import("../views/nihard"),
  },
  {
    path: "/Welding-wire",
    meta: { title: "Flux cored hardfacing wires | Hisan",
     keywords: 'Welding Wire, High-Quality Welding Wires, Industrial Welding Wire, Welding Materials, Arc Welding Wire, Stainless Steel Welding Wire, MIG Welding Wire, TIG Welding Wire, Welding Consumables, Durable Welding Solutions',
            description: 'Discover high-quality welding wires from HisanTech, designed for superior performance in various welding applications. Our welding wires provide excellent arc stability, low spatter, and strong welds, ensuring efficiency and reliability for industrial and commercial use.'},
    component: () => import("../views/welding"),
  },
  {
    path: "/wear",
    meta: { title: "wear",
     keywords: '',
            description: ''},
    component: () => import("../views/wear"),
  },

  {
    path: "/port",
    meta: { title: "port",
     keywords: '',
            description: ''},
    component: () => import("../views/port"),
  },
  {
    path: "/Chromium-carbide-overlay-wear-plates",
    meta: {
      title:
        "Premium quality Weld overlay wear plate of different grades| Hisan",
         keywords: '',
         description: ''
    },
    component: () => import("../views/cco"),
  },
  {
    path: "/cco",
    meta: {
      title:
        "Premium quality Weld overlay wear plate of different grades| Hisan",
     keywords: 'Chromium Carbide Overlay, CCO Plate, Wear Resistant Plate, Hardfacing Plate, HISAN, Chromium Carbide, Bimetal Plate, Abrasion Resistant Steel, CCO Manufacturer, Wear Plate Supplier, Chromium Carbide Overlay Plate, China CCO',
            description: 'Explore high-performance Chromium Carbide Overlay (CCO) plates by HISAN – engineered for extreme wear resistance and long service life. Our bimetallic wear plates are ideal for mining, cement, power, and other heavy industries.'
    },
    component: () => import("../views/cco"),
  },
  {
    path: "/detail",
    meta: { title: "detail",
     keywords: '',
            description: ''},
    component: () => import("../views/detail"),
  },
  {
    path: "/Contact-us",
    meta: { title: "Contact us Durability crafted with ingenuity | Hisan ",
     keywords: 'Contact HisanTech, Wear-Resistant Products Inquiry, Customer Support, Industrial Wear Solutions, Welding Consumables, Business Partnerships, Wear Plate Solutions, High-Quality Industrial Products, Contact for Wear Protection, Industrial Solutions Support',
            description: 'Get in touch with HisanTech for inquiries, support, and business partnerships. Our team is ready to assist you with high-quality wear-resistant products, including chromium carbide wear plates, welding wires, and customized solutions. Contact us today for more information.'},
    component: () => import("../views/contact"),
  },
  {
    path: "/product/:productName",
    meta: { title: "product",
     keywords: '',
            description: ''},
    name: "detail1",
    component: Detail,
    props: true,
  },
  {
    path: "/appliction/:productName",
    meta: { title: "appliction",
     keywords: '',
            description: ''},
    name: "appliction",
    component: Appliction,
    props: true,
  },
];


const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

router.beforeEach((to, from, next) => {
  const keywords = to.meta.keywords;
  const description = to.meta.description;
  if (keywords) {
    document.querySelector("meta[name='keywords']").setAttribute('content', keywords);
  } else {
    document.querySelector("meta[name='keywords']").setAttribute('content', 'chromium carbide overlay, wear plate, CCO plate, hardfacing, abrasion resistant steel, HISAN, wear solution, overlay plate manufacturer, China wear plate supplier, anti-wear technology, welded overlay, chrome carbide plate, HISAN wear plate, custom wear plate, bimetallic wear plate, hardfaced plate, flux cored hardfacing wires, hardfacing wires, cored wires, wear plate fabrication, bulk material handling'); // 清除或默认值
  }
  if (description) {
    document.querySelector("meta[name='description']").setAttribute('content', description);
  } else {
    document.querySelector("meta[name='description']").setAttribute('content', 'HISAN (Tianjin) Co., Ltd. is a trusted manufacturer and global supplier of premium Chromium Carbide Overlay (CCO) wear plates and hardfacing solutions. We provide bimetallic wear plates, custom fabrication, and flux cored hardfacing wires for mining, cement, steel, and bulk material handling industries.'); // 清除或默认值
  }
  next();
});

export default router;
